import { action } from '@ember/object';
import MenuItem from '../../../core/menu/item.gjs';

export default class SpdsActionButtonDropdownMenuItem extends MenuItem {
  variantClass = 'spds-action-button-dropdown-menu-item';

  @action
  onClick() {
    super.onClick(...arguments);

    this.args.toggleOpenState();
  }
}
